module.exports = __webpack_public_path__ + "img/phones.2fa21aec.png";